// Carahsoft is a live OData API, not a flat file, and has materially fewer fields
// than TD Synnex/Ingram Micro (no TAA, no EnergyStar, no EPEAT, no UNSPSC)

export type CarahsoftPriceListItem = {
  priceId: number | null
  vendorPartNumber: string | null
  carahsoftPartNumber: string | null
  vendor: string | null
  contract: string | null
  description: string | null
  listPrice: number | null
  contractPrice: number | null
  countryOfOrigin: string | null
}

export type CarahsoftCatalogRow = CarahsoftPriceListItem & {
  vendorId: number | null
  contractId: number | null
  carahsoftCreateDate: string | null
  carahsoftModDate: string | null
}

export function contractLabel(contract: string | null): string | null {
  if (!contract) return null
  if (contract.startsWith('GSA')) return 'GSA'
  if (contract.startsWith('OM')) return 'Open Market'
  return contract
}
